/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Clear_AllInputs */



/**
* | output |
* | --- |
* | "Clear All" |
*
* @param {Subtitle_Export_Clear_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_clear_all = /** @type {((inputs?: Subtitle_Export_Clear_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Clear_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer tout")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alles löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部清除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी साफ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar tudo")
	return /** @type {LocalizedString} */ ("Clear All")
});